import moment from 'moment'
moment.locale('pt-BR')

export default (pDate) => {
  if (!pDate) return 'Data desconhecida'
  return moment(pDate).format('ll') // ('dddd, DD MMM de YYYY')
}



// WEBPACK FOOTER //
// ./src/components/primitives/helpers/filters/FriendlyVerboseDate.js